// extracted by mini-css-extract-plugin
module.exports = {"instructionlist":"InstructionList_instructionlist__qPrY_"};